
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'locationText': {'fontFamily': `'Lato-Regular', sans-serif`,'marginBottom': `16px`,'color': `#ffffff`,},'hours': {'marginBottom': `16px`,},'locationHoursHeading': {'fontFamily': `'Lemon-Regular', sans-serif`,'fontSize': `small`,'fontWeight': `bold`,'marginBottom': `8px`,'color': `#ffffff`,'paddingLeft': `6px`,},'businessHours': {'marginBottom': `8px`,'color': `#ffffff`,'paddingLeft': `6px`,},'regularHours': {'marginBottom': `8px`,'color': `#ffffff`,'paddingLeft': `6px`,},'holidayHours': {'fontFamily': `'Lato-Regular'`,'fontStyle': `italic`,'marginBottom': `8px`,'color': `#be1e2d`,'paddingLeft': `6px`,},
        
      };
    };
  